import ModalPickerWithChooseButton from "components/Picker/ModalPickerWithChooseButton";
import RemovableTag from "components/Removables/RemovableTag";
import React from "react";
import { ModalPickerProps } from "../props";
import TagList from "./TagList";

interface Props extends ModalPickerProps<server.dto.TagForList> {
  mainArea: server.dto.MainAreas;
}

const TagModalPicker = (props: Props) => {
  const onChange = (value: server.dto.TagForList) => {
    props.nonInPageEditing?.onChange(value);
    props.inPageEditing?.onChange(value, true);
  };
  const excludeKeys = props.excludeKeys;
  return <>
    <ModalPickerWithChooseButton
      onNewClicked={() => { }}
      buttonLabel={RESX.Buttons.btnSelect}
      modalTitle={RESX.Tag.Tags}
      modalSize="tiny"
      renderModalContent={(closeModal) => <TagList
        excludeKeys={excludeKeys}
        mainArea={props.mainArea}
        onItemSelected={(tag) => {
          closeModal();
          onChange(tag);
        }}
      />}
      renderRemovable={(props) => <RemovableTag {...props} />}

      {...props}
    />
  </>;
};

export default TagModalPicker;